// extracted by mini-css-extract-plugin
export default {"container":"Infopage_container__Wjrz8","header":"Infopage_header__mVxgw","content":"Infopage_content__FrOBT"};